<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Gutschein erstellen </mat-card-title>
                </mat-card-header>
                <mat-card-content >
                    <mat-stepper [linear]="true" #stepper>
                        <mat-step [stepControl]="addFormUser" [formGroup]="addFormUser">
                            <ng-template matStepLabel>Kunde auswählen</ng-template>

                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Suchen...</mat-label>
                                        <input matInput formControlName="searchTerm" (change)="filterUsers()">

                                    </mat-form-field>
                                </div>
                            </div>
                            

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="example-container mat-elevation-z2">
                                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Auswählen
                                                </th>
                                                <td mat-cell *matCellDef="let element;let i = index;">
                                                    <mat-checkbox [checked]="selectedUser === i"
                                                        (change)="selectedUser = i" (click)="setActiveUser(element)">
                                                    </mat-checkbox>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="user">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Kunde
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="mat-column w70"
                                                    style="padding-right: 25px;">
                                                    <span>
                                                        {{element.person?.displayName}} ({{element.internalId}},
                                                        {{element.person.birthday | date: 'dd.MM.yyyy'}})
                                                    </span>

                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                                            </tr>
                                        </table>
                                        <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                                            Einträge
                                            gefunden...</span>
                                        <mat-paginator [length]="page.totalElements"
                                            class="paginator-centered  mat-elevation-z2" [pageSize]="page.size"
                                            [pageIndex]="page.number" (page)="loadPage($event)"
                                            [pageSizeOptions]="[4,8, 16, 24]" *ngIf="page">
                                        </mat-paginator>
                                    </div>
                                    <mat-error *ngIf="addFormUser.get('user').hasError('required')">
                                        Nutzer <strong>muss</strong> ausgewählt werden
                                    </mat-error>
                                </div>
                            </div>
                            <div>
                                <button mat-raised-button color="primary" matStepperNext>Weiter</button>
                            </div>
                        </mat-step>
                        <mat-step label="Aktion auswählen" [formGroup]="addFormEvent" [stepControl]="addFormEvent">
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Suchen...</mat-label>
                                        <input matInput formControlName="searchTerm" (change)="filterEvents()">

                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="example-container mat-elevation-z2">
                                        <table mat-table [dataSource]="dataSourceEvents" matSort
                                            class="mat-elevation-z2">
                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Auswählen
                                                </th>
                                                <td mat-cell *matCellDef="let element;let i = index;">
                                                    <mat-checkbox [checked]="selectedEvent === i"
                                                        (change)="selectedEvent = i" (click)="setActiveEvent(element)">
                                                    </mat-checkbox>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="user">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Aktion
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="mat-column w70"
                                                    style="padding-right: 25px;">
                                                    <span>
                                                        {{element.title}}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                                            </tr>
                                        </table>
                                        <span *ngIf="dataSourceEvents?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                                            Einträge
                                            gefunden...</span>
                                        <mat-paginator [length]="pageEvents.totalElements"
                                            class="paginator-centered   mat-elevation-z2" [pageSize]="pageEvents.size"
                                            [pageIndex]="pageEvents.number" (page)="loadPageEvent($event)"
                                            [pageSizeOptions]="[4,8, 16, 24]" *ngIf="pageEvents">
                                        </mat-paginator>
                                    </div>
                                    <mat-error *ngIf="addFormEvent.get('event').hasError('required')">
                                        Aktion <strong>muss</strong> ausgewählt werden
                                    </mat-error>
                                </div>
                            </div>
                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="primary" matStepperNext style="margin-left: 15px;">Weiter</button>
                            </div>                   
                        </mat-step>
                        <mat-step [formGroup]="addForm">
                            <ng-template matStepLabel>Einstellungen</ng-template>
                    
                            <div class="row">
                                <div class="col-sm-12">
                                    <p style="margin: 0;"><b>Kunde: </b> {{this.addFormUser.value.user?.person?.displayName}}</p>
                                    <p style="margin: 0;"><b>Aktion: </b> {{this.addFormEvent.value.event?.title}}</p>
                                    <br>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <mat-checkbox formControlName="emailNotify">
                                        <span [innerHtml]="'E-Mail Benachrichtigung'"></span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <mat-checkbox formControlName="force">
                                        <span [innerHtml]="'Kontingent anpassen/Beschränkungen ignorieren'"></span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <br>
                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="primary" matStepperNext style="margin-left: 15px;" (click)="createReservation()">Reservierung anlegen</button>
                            </div>
                        </mat-step>
                    </mat-stepper>
                </mat-card-content>
                <!-- <mat-card-actions align="end">
                    <button mat-button color="primary" [routerLink]="['../']">Abbrechen</button>
                    <button mat-button color="primary" (click)="createReservation()">Reservierung anlegen</button>
                </mat-card-actions> -->
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>